import { useState } from 'react'
import Layout1 from '@/layouts/Layout1'
import { Grid } from '@mui/material'

import CancelledPayment from './components/CancelledPayment'

import s from './styles.module.scss'

const CancelledPaymentPage = () => {
  const [isLoading] = useState(false)

  return (
    <Layout1 navbar isLoading={isLoading}>
      <Grid className={s.mainContainer}>
        <CancelledPayment />
      </Grid>
    </Layout1>
  )
}

export default CancelledPaymentPage
